import _asyncToGenerator from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = ["id"];
var _hoisted_2 = {
  class: "message-item"
};
var _hoisted_3 = ["onLongpress", "onContextmenu", "onTouchstart", "onTouchend", "onMouseover"];
var _hoisted_4 = {
  class: "delDialog-title"
};
import { ref, nextTick, computed, onMounted, onUnmounted } from '../../../adapter-vue';
import TUIChatEngine, { TUIStore, StoreName, TUITranslateService, TUIChatService } from '@tencentcloud/chat-uikit-engine';
import TUICore, { TUIConstants } from '@tencentcloud/tui-core';
import { outsideClick, getBoundingClientRect, getScrollInfo } from '@tencentcloud/universal-api';
import { TUIEmojiPlugin } from '@tencentcloud/tui-emoji-plugin';
import throttle from 'lodash/throttle';
import MessageGroupApplication from './message-group-application/index.vue';
import MessageText from './message-elements/message-text.vue';
import MessageImage from './message-elements/message-image.vue';
import MessageAudio from './message-elements/message-audio.vue';
import MessageFile from './message-elements/message-file.vue';
import MessageFace from './message-elements/message-face.vue';
import MessageCustom from './message-elements/message-custom.vue';
import MessageTip from './message-elements/message-tip.vue';
import MessageBubble from './message-elements/message-bubble.vue';
import MessageLocation from './message-elements/message-location.vue';
import MessageTimestamp from './message-elements/message-timestamp.vue';
import MessageVideo from './message-elements/message-video.vue';
import MessageTool from './message-tool/index.vue';
import MessageRevoked from './message-tool/message-revoked.vue';
import MessagePlugin from '../../../plugins/plugin-components/message-plugin.vue';
import ScrollButton from './scroll-button/index.vue';
import ReadReceiptPanel from './read-receipt-panel/index.vue';
import { isPluginMessage } from '../../../plugins/plugin-components/index';
import Dialog from '../../common/Dialog/index.vue';
import ImagePreviewer from '../../common/ImagePreviewer/index.vue';
import ProgressMessage from '../../common/ProgressMessage/index.vue';
import { emojiConfig } from '../utils/emoji-config';
import { isPC, isH5 } from '../../../utils/env';
import { isEnabledMessageReadReceiptGlobal, shallowCopyMessage, isCreateGroupCustomMessage, deepCopy } from '../utils/utils';
import { decodeText } from '../utils/decodeText';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    groupID: {
      type: String,
      default: ''
    },
    isGroup: {
      type: Boolean,
      default: false
    }
  },
  emits: ['handleEditor'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emits = __emit;
    var props = __props;
    // 表情回应相关
    var enabledEmojiPlugin = TUIStore.getData(StoreName.APP, 'enabledEmojiPlugin');
    var observer = null;
    var groupType;
    var sentReceiptMessageIDSet = new Set();
    var messageListRef = ref();
    var messageToolListRef = ref();
    // 上屏展示 messageList，不包含 isDeleted 为 true 的 message
    var messageList = ref();
    // 所有 messageList 序列，包含 isDeleted 为 true 的 message
    var allMessageList = ref();
    var isCompleted = ref(false);
    var currentConversationID = ref('');
    var currentLastMessage = ref();
    var nextReqMessageID = ref();
    var toggleID = ref('');
    var TYPES = ref(TUIChatEngine.TYPES);
    var isLongpressing = ref(false);
    var messageTarget = ref();
    var messageElementListRef = ref();
    var targetMessageDom = ref();
    var blinkMessageIDList = ref([]);
    var scrollButtonInstanceRef = ref();
    var isShowReadUserStatusPanel = ref(false);
    var readStatusMessage = ref();
    var beforeHistoryGetScrollHeight = ref(0);
    var isTopMessageDom = ref(false);
    // 图片预览相关
    var showImagePreview = ref(false);
    var currentImagePreview = ref();
    var imageMessageList = computed(() => {
      var _messageList$value;
      return messageList === null || messageList === void 0 || (_messageList$value = messageList.value) === null || _messageList$value === void 0 ? void 0 : _messageList$value.filter(item => {
        return !item.isRevoked && !item.hasRiskContent && item.type === TYPES.value.MSG_IMAGE;
      });
    });
    // 消息重发 Dialog
    var reSendDialogShow = ref(false);
    var resendMessageData = ref();
    var isShowEmojiPlugin = computed(() => {
      var msgPopMenuExtensionList = TUICore.getExtensionList(TUIConstants.TUIChat.EXTENSION.MSG_POP_MENU.EXT_ID, {
        enabledEmojiPlugin
      });
      return msgPopMenuExtensionList.some(item => {
        return item.text === 'TUIEmojiPlugin';
      });
    });
    // 事件监听
    onMounted(() => {
      // 消息 messageList
      TUIStore.watch(StoreName.CHAT, {
        messageList: onMessageListUpdated,
        messageSource: onMessageSourceUpdated,
        isCompleted: isCompletedUpdated
      });
      // 当前 ConversationID
      TUIStore.watch(StoreName.CONV, {
        currentConversationID: onCurrentConversationIDUpdated,
        currentConversation: onCurrentConversationUpdated
      });
      // 关闭消息操作 popMenu
      TUIStore.watch(StoreName.CUSTOM, {
        isShowMessagePopMenu: isShowMessagePopMenuUpdated
      });
      console.log("messagelist->", messageList.value);
    });
    // 绑定监听滚动事件 展示scroll-button
    onMounted(() => {
      var _messageListRef$value;
      (_messageListRef$value = messageListRef.value) === null || _messageListRef$value === void 0 || _messageListRef$value.addEventListener('scroll', handelScrollListScroll);
    });
    // 取消监听
    onUnmounted(() => {
      var _messageListRef$value2, _observer;
      TUIStore.unwatch(StoreName.CHAT, {
        messageList: onMessageListUpdated,
        messageSource: onMessageSourceUpdated,
        isCompleted: isCompletedUpdated
      });
      TUIStore.unwatch(StoreName.CONV, {
        currentConversationID: onCurrentConversationIDUpdated,
        currentConversation: onCurrentConversationUpdated
      });
      // 关闭消息操作 popMenu
      TUIStore.unwatch(StoreName.CUSTOM, {
        isShowMessagePopMenu: isShowMessagePopMenuUpdated
      });
      (_messageListRef$value2 = messageListRef.value) === null || _messageListRef$value2 === void 0 || _messageListRef$value2.removeEventListener('scroll', handelScrollListScroll);
      sentReceiptMessageIDSet.clear();
      (_observer = observer) === null || _observer === void 0 || _observer.disconnect();
      observer = null;
    });
    function onMessageListUpdated(_x) {
      return _onMessageListUpdated.apply(this, arguments);
    }
    function _onMessageListUpdated() {
      _onMessageListUpdated = _asyncToGenerator(function* (list) {
        var _observer2, _messageList$value2, _messageList$value3, _messageList$value4, _scrollButtonInstance2;
        console.log("消息列表发生了变化->", list);
        (_observer2 = observer) === null || _observer2 === void 0 || _observer2.disconnect();
        var oldLastMessage = currentLastMessage.value;
        var hasEmojiReaction = false;
        allMessageList.value = list;
        messageList.value = list === null || list === void 0 ? void 0 : list.filter(message => {
          var _message$reactionList;
          if ((_message$reactionList = message.reactionList) !== null && _message$reactionList !== void 0 && _message$reactionList.length && !message.isDeleted) {
            hasEmojiReaction = true;
          }
          return !message.isDeleted;
        });
        if (!((_messageList$value2 = messageList.value) !== null && _messageList$value2 !== void 0 && _messageList$value2.length)) {
          currentLastMessage.value = {};
          return;
        }
        var newLastMessage = (_messageList$value3 = messageList.value) === null || _messageList$value3 === void 0 ? void 0 : _messageList$value3[((_messageList$value4 = messageList.value) === null || _messageList$value4 === void 0 ? void 0 : _messageList$value4.length) - 1];
        if (messageTarget.value) {
          var _messageList$value5;
          if (((_messageList$value5 = messageList.value) === null || _messageList$value5 === void 0 ? void 0 : _messageList$value5.findIndex(message => {
            var _messageTarget$value;
            return (message === null || message === void 0 ? void 0 : message.ID) === ((_messageTarget$value = messageTarget.value) === null || _messageTarget$value === void 0 ? void 0 : _messageTarget$value.ID);
          })) >= 0) {
            var tempMessage = messageTarget.value;
            messageTarget.value = undefined;
            yield scrollToPosition({
              scrollToMessage: tempMessage
            });
            yield blinkMessage(tempMessage === null || tempMessage === void 0 ? void 0 : tempMessage.ID);
          }
        } else if (beforeHistoryGetScrollHeight.value) {
          yield scrollToPosition({
            scrollToOffset: {
              bottom: beforeHistoryGetScrollHeight.value
            }
          });
          beforeHistoryGetScrollHeight.value = 0;
        } else if ((_scrollButtonInstance2 = scrollButtonInstanceRef.value) !== null && _scrollButtonInstance2 !== void 0 && _scrollButtonInstance2.isScrollButtonVisible && (newLastMessage === null || newLastMessage === void 0 ? void 0 : newLastMessage.flow) === 'in') {
          return;
        } else if (newLastMessage !== null && newLastMessage !== void 0 && newLastMessage.ID && JSON.stringify(oldLastMessage) !== JSON.stringify(newLastMessage)) {
          yield scrollToPosition({
            scrollToBottom: true
          });
        } else if (hasEmojiReaction && isCurrentListInBottomPosition()) {
          yield scrollToPosition({
            scrollToBottom: true
          });
        }
        currentLastMessage.value = Object.assign({}, newLastMessage);
        if (isEnabledMessageReadReceiptGlobal()) {
          nextTick(() => bindIntersectionObserver());
        }
      });
      return _onMessageListUpdated.apply(this, arguments);
    }
    function onCurrentConversationUpdated(conversation) {
      // let lastMessage = conversation?.lastMessage;
      // // console.log("lastMessage->",lastMessage);
    }
    function isCurrentListInBottomPosition() {
      return messageListRef.value && typeof messageListRef.value.scrollTop === 'number' && typeof messageListRef.value.scrollHeight === 'number' && typeof messageListRef.value.clientHeight === 'number' && Math.ceil(messageListRef.value.scrollTop + messageListRef.value.clientHeight) >= messageListRef.value.scrollHeight;
    }
    function scrollToPosition() {
      return _scrollToPosition.apply(this, arguments);
    }
    function _scrollToPosition() {
      _scrollToPosition = _asyncToGenerator(function* () {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return new Promise((resolve, reject) => {
          requestAnimationFrame(() => {
            if (!messageListRef.value) {
              reject();
            }
            var container = messageListRef.value;
            if (config.scrollToBottom) {
              container.scrollTop = container.scrollHeight;
            } else if (config.scrollToMessage) {
              var _messageElementListRe2;
              var _targetMessageDom = (_messageElementListRe2 = messageElementListRef.value) === null || _messageElementListRe2 === void 0 ? void 0 : _messageElementListRe2.find(dom => {
                var _config$scrollToMessa;
                return (dom === null || dom === void 0 ? void 0 : dom.id) === "tui-".concat((_config$scrollToMessa = config.scrollToMessage) === null || _config$scrollToMessa === void 0 ? void 0 : _config$scrollToMessa.ID);
              });
              if (_targetMessageDom !== null && _targetMessageDom !== void 0 && _targetMessageDom.scrollIntoView) {
                _targetMessageDom.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest'
                });
              }
            } else if (config.scrollToOffset) {
              var _config$scrollToOffse, _config$scrollToOffse2;
              if ((_config$scrollToOffse = config.scrollToOffset) !== null && _config$scrollToOffse !== void 0 && _config$scrollToOffse.top) {
                container.scrollTop = config.scrollToOffset.top;
              } else if ((_config$scrollToOffse2 = config.scrollToOffset) !== null && _config$scrollToOffse2 !== void 0 && _config$scrollToOffse2.bottom) {
                container.scrollTop = container.scrollHeight - config.scrollToOffset.bottom;
              }
            }
            resolve();
          });
        });
      });
      return _scrollToPosition.apply(this, arguments);
    }
    function onMessageSourceUpdated(_x2) {
      return _onMessageSourceUpdated.apply(this, arguments);
    }
    function _onMessageSourceUpdated() {
      _onMessageSourceUpdated = _asyncToGenerator(function* (message) {
        // messageSource change 有两种情况
        // 1. messageSource change -> 未命中缓存 -> messageList change,
        // 2. messageSource change -> 命中缓存 -> messageList not change
        // 只有第二种情况需要在此处监听时增加 scrollToTarget
        messageTarget.value = message;
        if (messageTarget.value) {
          var _messageList$value6;
          if (((_messageList$value6 = messageList.value) === null || _messageList$value6 === void 0 ? void 0 : _messageList$value6.findIndex(message => {
            var _messageTarget$value2;
            return (message === null || message === void 0 ? void 0 : message.ID) === ((_messageTarget$value2 = messageTarget.value) === null || _messageTarget$value2 === void 0 ? void 0 : _messageTarget$value2.ID);
          })) >= 0) {
            var tempMessage = messageTarget.value;
            messageTarget.value = undefined;
            yield scrollToPosition({
              scrollToMessage: tempMessage
            });
            yield blinkMessage(tempMessage === null || tempMessage === void 0 ? void 0 : tempMessage.ID);
          }
        }
      });
      return _onMessageSourceUpdated.apply(this, arguments);
    }
    function isCompletedUpdated(flag) {
      isCompleted.value = flag;
    }
    function isShowMessagePopMenuUpdated(isShow) {
      if (!isShow) {
        toggleID.value = '';
      }
    }
    // 监听回调函数
    var onCurrentConversationIDUpdated = conversationID => {
      currentConversationID.value = conversationID;
      // 增加清空 messageList 条件，当前无正在开启会话时才清空
      // 避免 H5 二次打开相同会话（已有 messageList 缓存）下，onCurrentConversationIDUpdated 晚与 onMessageListUpdated 触发导致消息被清空
      if (!currentConversationID.value) {
        messageList.value = [];
      }
      // 开启已读回执的状态 群聊缓存群类型
      if (isEnabledMessageReadReceiptGlobal()) {
        var {
          groupProfile
        } = TUIStore.getConversationModel(conversationID) || {};
        groupType = groupProfile === null || groupProfile === void 0 ? void 0 : groupProfile.type;
      }
    };
    // 获取历史消息
    var getHistoryMessageList = () => {
      var _messageListRef$value3;
      TUIChatService.getMessageList().then(res => {
        var {
          nextReqMessageID: ID
        } = res.data;
        nextReqMessageID.value = ID;
      });
      // 获取历史消息后，保持滚动条在原来位置
      beforeHistoryGetScrollHeight.value = (_messageListRef$value3 = messageListRef.value) === null || _messageListRef$value3 === void 0 ? void 0 : _messageListRef$value3.scrollHeight;
    };
    var openComplaintLink = type => {
      window.open(type.url);
    };
    // 图片预览
    var handleImagePreview = message => {
      if (showImagePreview.value || currentImagePreview.value || isLongpressing.value) {
        return;
      }
      showImagePreview.value = true;
      currentImagePreview.value = message;
    };
    // 关闭图片预览
    var onImagePreviewerClose = () => {
      showImagePreview.value = false;
      currentImagePreview.value = null;
    };
    // 消息操作
    var handleToggleMessageItem = function handleToggleMessageItem(e, message) {
      var isLongpress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (isLongpress) {
        isLongpressing.value = true;
      }
      toggleID.value = message.ID;
      filterTopMessageDom(e.target);
    };
    var handleToggleMessageItemForPC = (e, message) => {
      if (isPC) {
        var _messageElementListRe;
        toggleID.value = message.ID;
        targetMessageDom.value = (_messageElementListRe = messageElementListRef.value) === null || _messageElementListRe === void 0 ? void 0 : _messageElementListRe.find(dom => (dom === null || dom === void 0 ? void 0 : dom.id) === "tui-".concat(message.ID));
        nextTick(() => {
          var _messageToolListRef$v;
          var ignoreDomRefs = messageToolListRef.value && ((_messageToolListRef$v = messageToolListRef.value[0]) === null || _messageToolListRef$v === void 0 ? void 0 : _messageToolListRef$v.messageToolDom);
          outsideClick.listen({
            domRefs: targetMessageDom.value,
            ignoreDomRefs: ignoreDomRefs,
            handler: closeChatPop,
            button: e.button
          });
          filterTopMessageDom(e.target);
        });
      }
    };
    // 判断 chat 可视区域顶部的 message 元素
    function filterTopMessageDom(toggleMessageElement) {
      // 获取元素
      var chatElement = document.getElementById('tui-chat-main');
      var safeTop = 160; // 防止被安全提示遮挡
      var messageElementRect = toggleMessageElement.getBoundingClientRect(); // 当前 message 距离可视窗口的信息
      var ChatElementRect = chatElement.getBoundingClientRect();
      isTopMessageDom.value = messageElementRect.top - ChatElementRect.top < safeTop;
    }
    // h5 long press
    var timer;
    var handleH5LongPress = (e, message, type) => {
      if (!isH5) return;
      function longPressHandler() {
        clearTimeout(timer);
        handleToggleMessageItem(e, message);
      }
      function touchStartHandler() {
        timer = setTimeout(longPressHandler, 500);
      }
      function touchEndHandler() {
        clearTimeout(timer);
      }
      switch (type) {
        case 'touchstart':
          touchStartHandler();
          break;
        case 'touchend':
          touchEndHandler();
          setTimeout(() => {
            isLongpressing.value = false;
          }, 200);
          break;
      }
    };
    // 消息撤回后，编辑消息
    var handleEdit = message => {
      emits('handleEditor', message, 'reedit');
    };
    // 重发消息
    var resendMessage = message => {
      reSendDialogShow.value = true;
      resendMessageData.value = message;
    };
    var resendMessageConfirm = () => {
      reSendDialogShow.value = !reSendDialogShow.value;
      var messageModel = resendMessageData.value;
      messageModel.resendMessage();
    };
    function blinkMessage(messageID) {
      return new Promise(resolve => {
        var index = blinkMessageIDList.value.indexOf(messageID);
        if (index < 0) {
          blinkMessageIDList.value.push(messageID);
          var _timer = setTimeout(() => {
            blinkMessageIDList.value.splice(blinkMessageIDList.value.indexOf(messageID), 1);
            clearTimeout(_timer);
            resolve();
          }, 3000);
        }
      });
    }
    // 滚动到最新消息
    function scrollToLatestMessage() {
      return _scrollToLatestMessage.apply(this, arguments);
    }
    function _scrollToLatestMessage() {
      _scrollToLatestMessage = _asyncToGenerator(function* () {
        var {
          scrollHeight
        } = yield getScrollInfo('#messageScrollList');
        var {
          height
        } = yield getBoundingClientRect('#messageScrollList');
        if (messageListRef.value) {
          messageListRef.value.scrollTop = scrollHeight - height;
        }
      });
      return _scrollToLatestMessage.apply(this, arguments);
    }
    var handelScrollListScroll = throttle(function (e) {
      var _scrollButtonInstance;
      (_scrollButtonInstance = scrollButtonInstanceRef.value) === null || _scrollButtonInstance === void 0 || _scrollButtonInstance.judgeScrollOverOneScreen(e);
    }, 150, {
      leading: true
    });
    function bindIntersectionObserver() {
      return _bindIntersectionObserver.apply(this, arguments);
    } // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function _bindIntersectionObserver() {
      _bindIntersectionObserver = _asyncToGenerator(function* () {
        var _observer3, _messageListRef$value4;
        if (!messageList.value || !messageListRef.value || messageList.value.length === 0) {
          return;
        }
        if (groupType === TYPES.value.GRP_AVCHATROOM || groupType === TYPES.value.GRP_COMMUNITY) {
          // 直播群以及社群不进行消息的已读回执监听
          return;
        }
        var mappingFromIDToMessage = {};
        (_observer3 = observer) === null || _observer3 === void 0 || _observer3.disconnect();
        observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            var {
              isIntersecting,
              target
            } = entry;
            if (isIntersecting) {
              var _msgModel$readReceipt;
              var {
                msgDom,
                msgModel
              } = mappingFromIDToMessage[target.id];
              if (msgModel && !((_msgModel$readReceipt = msgModel.readReceiptInfo) !== null && _msgModel$readReceipt !== void 0 && _msgModel$readReceipt.isPeerRead) && !sentReceiptMessageIDSet.has(msgModel.ID)) {
                var _observer4;
                TUIChatService.sendMessageReadReceipt([msgModel]);
                sentReceiptMessageIDSet.add(msgModel.ID);
                (_observer4 = observer) === null || _observer4 === void 0 || _observer4.unobserve(msgDom);
              }
            }
          });
        }, {
          root: messageListRef.value,
          threshold: 0.7
        });
        var arrayOfMessageLi = (_messageListRef$value4 = messageListRef.value) === null || _messageListRef$value4 === void 0 ? void 0 : _messageListRef$value4.querySelectorAll('.message-li');
        if (arrayOfMessageLi) {
          var _loop = function* _loop() {
            var messageElement = arrayOfMessageLi[i];
            var matchingMessage = messageList.value.find(message => {
              return messageElement.id.slice(4) === message.ID;
            });
            if (matchingMessage && matchingMessage.needReadReceipt && matchingMessage.flow === 'in') {
              var _observer5;
              mappingFromIDToMessage[messageElement.id] = {
                msgDom: messageElement,
                msgModel: matchingMessage
              };
              (_observer5 = observer) === null || _observer5 === void 0 || _observer5.observe(messageElement);
            }
          };
          for (var i = 0; i < (arrayOfMessageLi === null || arrayOfMessageLi === void 0 ? void 0 : arrayOfMessageLi.length); ++i) {
            yield* _loop();
          }
        }
      });
      return _bindIntersectionObserver.apply(this, arguments);
    }
    var isSignalingMessage = message => {
      return (message === null || message === void 0 ? void 0 : message.type) === TYPES.value.MSG_CUSTOM && (message === null || message === void 0 ? void 0 : message.getSignalingInfo());
    };
    function setReadReceiptPanelVisible(visible, message) {
      if (!visible) {
        readStatusMessage.value = undefined;
      } else {
        readStatusMessage.value = message;
      }
      isShowReadUserStatusPanel.value = visible;
    }
    function closeChatPop() {
      toggleID.value = '';
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["tui-chat", [!_unref(isPC) ? 'tui-chat-h5' : '']])
      }, [_createElementVNode("div", {
        id: "tui-chat-main",
        class: "tui-chat-main",
        onClick: closeChatPop
      }, [__props.isGroup ? (_openBlock(), _createBlock(MessageGroupApplication, {
        key: props.groupID,
        groupID: props.groupID
      }, null, 8, ["groupID"])) : _createCommentVNode("", true), _createElementVNode("ul", {
        id: "messageScrollList",
        ref_key: "messageListRef",
        ref: messageListRef,
        class: "tui-message-list"
      }, [!_unref(isCompleted) ? (_openBlock(), _createElementBlock("p", {
        key: 0,
        class: "message-more",
        onClick: getHistoryMessageList
      }, _toDisplayString(_unref(TUITranslateService).t("TUIChat.查看更多")), 1)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messageList), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          id: 'tui-' + item.ID,
          key: item.ID,
          ref_for: true,
          ref_key: "messageElementListRef",
          ref: messageElementListRef,
          class: "message-li"
        }, [_createVNode(MessageTimestamp, {
          currTime: item.time,
          prevTime: index > 0 ? _unref(messageList)[index - 1].time : 0
        }, null, 8, ["currTime", "prevTime"]), _createElementVNode("div", _hoisted_2, [item.type === _unref(TYPES).MSG_GRP_TIP || _unref(isCreateGroupCustomMessage)(item) ? (_openBlock(), _createBlock(MessageTip, {
          key: 0,
          content: item.getMessageContent(),
          blinkMessageIDList: _unref(blinkMessageIDList),
          onBlinkMessage: blinkMessage
        }, null, 8, ["content", "blinkMessageIDList"])) : item.isRevoked ? (_openBlock(), _createBlock(MessageRevoked, {
          key: 1,
          isEdit: item.type === _unref(TYPES).MSG_TEXT,
          messageItem: item,
          onMessageEdit: $event => handleEdit(item)
        }, null, 8, ["isEdit", "messageItem", "onMessageEdit"])) : _unref(isPluginMessage)(item) ? (_openBlock(), _createBlock(MessagePlugin, {
          key: 2,
          message: _unref(deepCopy)(item),
          blinkMessageIDList: _unref(blinkMessageIDList),
          onResendMessage: resendMessage,
          onHandleToggleMessageItem: handleToggleMessageItem,
          onHandleH5LongPress: handleH5LongPress
        }, null, 8, ["message", "blinkMessageIDList"])) : (_openBlock(), _createElementBlock("div", {
          key: 3,
          onLongpress: $event => handleToggleMessageItem($event, item, true),
          onContextmenu: _withModifiers($event => handleToggleMessageItemForPC($event, item), ["prevent", "right"]),
          onTouchstart: $event => handleH5LongPress($event, item, 'touchstart'),
          onTouchend: $event => handleH5LongPress($event, item, 'touchend'),
          onMouseover: $event => handleH5LongPress($event, item, 'touchend')
        }, [_createVNode(MessageBubble, {
          messageItem: JSON.parse(JSON.stringify(item)),
          content: item.getMessageContent(),
          blinkMessageIDList: _unref(blinkMessageIDList),
          onResendMessage: $event => resendMessage(item),
          onBlinkMessage: blinkMessage,
          onSetReadReceiptPanelVisible: setReadReceiptPanelVisible
        }, {
          messageElement: _withCtx(() => [item.type === _unref(TYPES).MSG_TEXT ? (_openBlock(), _createBlock(MessageText, {
            key: 0,
            content: _unref(decodeText)(item.payload.text)
          }, null, 8, ["content"])) : _createCommentVNode("", true), item.type === _unref(TYPES).MSG_IMAGE ? (_openBlock(), _createBlock(ProgressMessage, {
            key: 1,
            content: item.getMessageContent(),
            messageItem: item
          }, {
            default: _withCtx(() => [_createVNode(MessageImage, {
              content: item.getMessageContent(),
              messageItem: item,
              onPreviewImage: handleImagePreview
            }, null, 8, ["content", "messageItem"])]),
            _: 2
          }, 1032, ["content", "messageItem"])) : _createCommentVNode("", true), item.type === _unref(TYPES).MSG_VIDEO ? (_openBlock(), _createBlock(ProgressMessage, {
            key: 2,
            content: item.getMessageContent(),
            messageItem: item
          }, {
            default: _withCtx(() => [_createVNode(MessageVideo, {
              content: item.getMessageContent(),
              messageItem: item
            }, null, 8, ["content", "messageItem"])]),
            _: 2
          }, 1032, ["content", "messageItem"])) : _createCommentVNode("", true), item.type === _unref(TYPES).MSG_AUDIO ? (_openBlock(), _createBlock(MessageAudio, {
            key: 3,
            content: item.getMessageContent(),
            messageItem: item
          }, null, 8, ["content", "messageItem"])) : _createCommentVNode("", true), item.type === _unref(TYPES).MSG_FILE ? (_openBlock(), _createBlock(ProgressMessage, {
            key: 4,
            content: item.getMessageContent(),
            messageItem: item
          }, {
            default: _withCtx(() => [_createVNode(MessageFile, {
              content: item.getMessageContent(),
              messageItem: item
            }, null, 8, ["content", "messageItem"])]),
            _: 2
          }, 1032, ["content", "messageItem"])) : _createCommentVNode("", true), item.type === _unref(TYPES).MSG_FACE ? (_openBlock(), _createBlock(MessageFace, {
            key: 5,
            content: item.getMessageContent(),
            isPC: _unref(isPC)
          }, null, 8, ["content", "isPC"])) : _createCommentVNode("", true), item.type === _unref(TYPES).MSG_LOCATION ? (_openBlock(), _createBlock(MessageLocation, {
            key: 6,
            content: item.getMessageContent()
          }, null, 8, ["content"])) : _createCommentVNode("", true), item.type === _unref(TYPES).MSG_CUSTOM ? (_openBlock(), _createBlock(MessageCustom, {
            key: 7,
            content: item.getMessageContent(),
            messageItem: item
          }, null, 8, ["content", "messageItem"])) : _createCommentVNode("", true)]),
          TUIEmojiPlugin: _withCtx(() => [_unref(isShowEmojiPlugin) && item.reactionList.length > 0 ? (_openBlock(), _createBlock(_unref(TUIEmojiPlugin), {
            key: 0,
            type: "reaction-detail",
            emojiConfig: _unref(emojiConfig),
            message: _unref(shallowCopyMessage)(item)
          }, null, 8, ["emojiConfig", "message"])) : _createCommentVNode("", true)]),
          _: 2
        }, 1032, ["messageItem", "content", "blinkMessageIDList", "onResendMessage"])], 40, _hoisted_3)), item.ID === _unref(toggleID) ? (_openBlock(), _createBlock(MessageTool, {
          key: 4,
          ref_for: true,
          ref_key: "messageToolListRef",
          ref: messageToolListRef,
          class: _normalizeClass(['message-tool', item.flow === 'out' ? 'message-tool-out' : 'message-tool-in', _unref(isTopMessageDom) ? 'message-tool-bottom' : '']),
          messageItem: item
        }, {
          TUIEmojiPlugin: _withCtx(() => [_unref(isShowEmojiPlugin) ? (_openBlock(), _createBlock(_unref(TUIEmojiPlugin), {
            key: 0,
            message: item,
            emojiConfig: _unref(emojiConfig)
          }, null, 8, ["message", "emojiConfig"])) : _createCommentVNode("", true)]),
          _: 2
        }, 1032, ["class", "messageItem"])) : _createCommentVNode("", true)])], 8, _hoisted_1);
      }), 128))], 512), _createVNode(ScrollButton, {
        ref_key: "scrollButtonInstanceRef",
        ref: scrollButtonInstanceRef,
        onScrollToLatestMessage: scrollToLatestMessage
      }, null, 512), _unref(reSendDialogShow) ? (_openBlock(), _createBlock(Dialog, {
        key: 1,
        class: "resend-dialog",
        show: _unref(reSendDialogShow),
        isH5: !_unref(isPC),
        center: true,
        isHeaderShow: _unref(isPC),
        onSubmit: _cache[0] || (_cache[0] = $event => resendMessageConfirm()),
        "onUpdate:show": _cache[1] || (_cache[1] = e => reSendDialogShow.value = e)
      }, {
        default: _withCtx(() => [_createElementVNode("p", _hoisted_4, _toDisplayString(_unref(TUITranslateService).t("TUIChat.确认重发该消息？")), 1)]),
        _: 1
      }, 8, ["show", "isH5", "isHeaderShow"])) : _createCommentVNode("", true), _unref(showImagePreview) ? (_openBlock(), _createBlock(ImagePreviewer, {
        key: 2,
        currentImage: _unref(currentImagePreview),
        imageList: _unref(imageMessageList),
        onClose: onImagePreviewerClose
      }, null, 8, ["currentImage", "imageList"])) : _createCommentVNode("", true), _unref(isShowReadUserStatusPanel) ? (_openBlock(), _createBlock(ReadReceiptPanel, {
        key: 3,
        message: Object.assign({}, _unref(readStatusMessage)),
        onSetReadReceiptPanelVisible: setReadReceiptPanelVisible
      }, null, 8, ["message"])) : _createCommentVNode("", true)])], 2);
    };
  }
});